import {Locale} from '../../../../../../provider/locale/localization';
import {DatePeriodEnum} from '../../../../../../util/date';

export const PERIOD_OPTIONS = [
    {
        label: <Locale stringKey="REVIEWS_ANALYSIS__FILTER__PERIOD__DAY" />,
        value: DatePeriodEnum.Day,
    },
    {
        label: <Locale stringKey="REVIEWS_ANALYSIS__FILTER__PERIOD__WEEK" />,
        value: DatePeriodEnum.Week,
    },
    {
        label: <Locale stringKey="REVIEWS_ANALYSIS__FILTER__PERIOD__MONTH" />,
        value: DatePeriodEnum.Month,
    },
    {
        label: <Locale stringKey="REVIEWS_ANALYSIS__FILTER__PERIOD__PREVIOUS_FULL_MONTH" />,
        value: DatePeriodEnum.PreviousFullMonth,
    },
    {
        label: <Locale stringKey="REVIEWS_ANALYSIS__FILTER__PERIOD__QUARTER" />,
        value: DatePeriodEnum.Quarter,
    },
    {
        label: <Locale stringKey="REVIEWS_ANALYSIS__FILTER__PERIOD__CUSTOM" />,
        value: DatePeriodEnum.Custom,
    },
];

export const REVIEWS_ANALYTICS_DELAY_DAYS = 2;
